export enum AppActions {
  INIT = 'p0',
  SET_ACTIVE = 'p1',
  FAVORITE = 'p2',
  COPY_LINK = 'p3',
  UTILITY = 'p4',
  ENTITIES = 'p5',
  CLEAR_ROWS = 'p6'
}
